import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PageFooterNew from './PageFooterNew';
import SiftLogoBlackNew from 'components/Icons/SiftLogoBlackNew';

import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  return {
    container: {
      marginLeft: theme.spacing(7.5),
      marginRight: theme.spacing(7.5),
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      [theme.breakpoints.down('sm')]: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: theme.spacing(1),
        alignItems: 'center',
      },
    },
    header: {
      marginTop: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(1),
      },
    },
    children: {
      flex: '1 1 auto',
      minWidth: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
        marginTop: 0,
        textAlign: 'center',
        justifyContent: 'flex-start',
        alignContent: 'center',
        alignItems: 'center',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
      '& > div': {
        width: '100%',
      },
    },
    footer: {
      marginTop: theme.spacing(4),
      display: 'flex',
      height: 60,
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        position: 'relative',
        marginBottom: theme.spacing(),
        alignContent: 'center',
        flexDirection: 'column',
      },
    },
  };
};

class SplitPageRight extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.node,
  };

  render() {
    const { classes, children } = this.props;
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <SiftLogoBlackNew />
        </div>
        <div className={classes.children}>
          <div>{children}</div>
        </div>
        <div className={classes.footer}>
          <div>
            <PageFooterNew />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(SplitPageRight);
